import React, { useState, useEffect } from "react";
import "./BagContent.scss";
import "./BagContentMobile.scss";
import { FaMinus, FaPlus, FaTimes, FaTrash } from "react-icons/fa";

import { useAppContext } from "../../Components/AppProvider";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { setRedirect } from "../../PageCostumerProfile/PCPContents/utils/redirect";

function BagContent() {
  const [insideBag, setInsideBag] = useState([]);
  const {
    customerId,
    customerEmail,
    setHasBagCount,
    addressId,
    setUpdateOrderHistoryNav,
  } = useAppContext(); // ✅ get customerId from context
  const [loading, setLoading] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 600 });
  const navigate = useNavigate();
  // fetch products inside bag
  useEffect(() => {
    async function fetchBagContent() {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/bag/get-inside-bag/${customerId}`,
          {
            credentials: "include",
          }
        );

        if (!res.ok) {
          console.error("HTTP error:", res.status);
          return;
        }

        const data = await res.json();
        if (Array.isArray(data.InsideBag)) {
          setInsideBag(data.InsideBag);
          //console.log("data.InsideBag :", data.InsideBag);
        } else {
          console.error("Invalid response:", data);
          setInsideBag([]);
        }
      } catch (err) {
        console.error("Failed to fetch bag contents", err);
        setInsideBag([]);
      }
    }

    if (customerId) {
      fetchBagContent();
    }
  }, [customerId]);

  // update quantity locally
  const updateQuantity = async (bagId, newQty) => {
    if (newQty <= 0) {
      deleteItem(bagId);
      return;
    }

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/bag/update-quantity/${bagId}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ quantity: newQty }),
          credentials: "include",
        }
      );

      if (!res.ok) throw new Error("Failed to update quantity");

      // update frontend state too
      setInsideBag((prev) =>
        prev.map((item) =>
          item.B_ID === bagId ? { ...item, B_Quantity: newQty } : item
        )
      );

      setHasBagCount(true); // optional: trigger bag count refresh
    } catch (err) {
      console.error(err);
    }
  };

  // calculate total
  const total = insideBag.reduce(
    (sum, item) => sum + item.B_Quantity * item.PD_OriginalPrice,
    0
  );

  const [checked, setChecked] = useState([]);

  useEffect(() => {
    if (insideBag.length > 0) {
      // initialize all unchecked when insideBag changes
      setChecked(new Array(insideBag.length).fill(false));
    }
  }, [insideBag]);

  const [checkedItems, setCheckedItems] = useState(new Set());

  // toggle all
  const handleCheckAll = (e) => {
    if (e.target.checked) {
      // select all bag IDs
      setCheckedItems(new Set(insideBag.map((item) => item.B_ID)));
    } else {
      setCheckedItems(new Set());
      setIsSummaryOpen(false);
    }
  };

  // toggle single row
  const handleCheckRow = (bagId) => (e) => {
    setCheckedItems((prev) => {
      const newSet = new Set(prev);
      if (e.target.checked) {
        newSet.add(bagId);
      } else {
        newSet.delete(bagId);
        if (!checkedItems) {
          setIsSummaryOpen(false);
        }
      }
      return newSet;
    });
  };

  const allChecked =
    insideBag.length > 0 && checkedItems.size === insideBag.length;

  const deleteItem = async (bagId) => {
    if (
      !window.confirm(
        "Are you sure you want to remove this item from your bag?"
      )
    ) {
      return;
    }

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/bag/delete/${bagId}`,
        {
          method: "DELETE",
          credentials: "include",
        }
      );

      if (!res.ok) throw new Error("Failed to delete item");

      // remove from frontend state
      setInsideBag((prev) => prev.filter((item) => item.B_ID !== bagId));

      // also remove from checked items set
      setCheckedItems((prev) => {
        const newSet = new Set(prev);
        newSet.delete(bagId);
        return newSet;
      });

      setHasBagCount(true); // trigger bag count refresh
    } catch (err) {
      console.error("Delete failed:", err);
    }
  };
  // place order handler
  const handlePlaceOrder = async () => {
    if (addressId === null) {
      alert("❌ Please add a delivery address before proceeding to payment.");
      setRedirect(0, 1);
      setUpdateOrderHistoryNav(true);
      navigate("/customer-profile");
      return;
    }
    if (checkedItems.size === 0) return; // no items selected

    // confirm first
    if (!window.confirm("Are you sure you want to place this order?")) {
      return; // user canceled
    }

    const selectedItems = insideBag.filter((item) =>
      checkedItems.has(item.B_ID)
    );

    const payload = {
      items: selectedItems.map((item) => ({
        cId: customerId,
        productId: item.PD_ID,
        type: item.PD_ProductType,
        stock: item.PD_Stock,
        quantity: item.B_Quantity,
        unitPrice:
          item.PD_ProductType === "onhand"
            ? item.PD_SalePrice
            : item.PD_OriginalPrice,
        downpayment: item.PD_DownPayment,
      })),
      deleteItems: selectedItems.map((item) => ({
        cId: customerId,
        bagId: item.B_ID,
      })),
      email: customerEmail,
      customerId: customerId,
    };

    try {
      setLoading(true); // 🔹 start loading

      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/orders/place`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) throw new Error("Failed to place order");

      const data = await res.json();
      alert("✅ Order placed successfully!");

      setInsideBag((prev) =>
        prev.filter((item) => !checkedItems.has(item.B_ID))
      );
      setCheckedItems(new Set());
      setHasBagCount(true);

      localStorage.setItem("redirect", JSON.stringify({ nav: 1, side: 0 }));
      navigate("/customer-profile");
    } catch (err) {
      console.error("Order failed:", err);
      alert("❌ Failed to place order. Please try again.");
    } finally {
      setLoading(false); // 🔹 stop loading
    }
  };
  const [isSummaryOpen, setIsSummaryOpen] = useState(false);
  const handleMobileOrder = () => {
    if (checkedItems.size === 0) {
      alert("Please select items first");
      return;
    } // no items selected

    setIsSummaryOpen(true);
  };
  return (
    <div className="BC-Container">
      <main className="bag-prod-list-container">
        <div className="list-title">
          <div className="input-check-wrapper">
            <input
              type="checkbox"
              checked={allChecked}
              onChange={handleCheckAll}
            />
          </div>
          <h1>MY BAG ({insideBag.length})</h1>
        </div>

        <div className="bag-prod-list-wraper">
          {insideBag.length ? (
            insideBag.map((product, index) => (
              <div key={product.B_ID || index} className="bag-prod-item">
                <div className="input-check-wrapper">
                  <input
                    type="checkbox"
                    checked={checkedItems.has(product.B_ID)}
                    onChange={handleCheckRow(product.B_ID)}
                  />
                </div>

                <img
                  src={`${process.env.REACT_APP_BASE_URL}Assets/Products/${product.PD_ID}/${product.PD_ProductPicPath[0]}`}
                  alt={product.PD_Name}
                />

                <div className="bag-prod-details-wrapper">
                  <div className="bag-prod-details-first">
                    <span className="prod-name-span">{product.PD_Name}</span>
                    <span className="prod-total-price">
                      {product.PD_ProductType === "onhand"
                        ? product.PD_SalePrice === 0
                          ? `PHP ${
                              product.B_Quantity * product.PD_OriginalPrice
                            }`
                          : `PHP ${product.B_Quantity * product.PD_SalePrice}`
                        : `PHP ${
                            product.B_Quantity * product.PD_OriginalPrice
                          }`}
                    </span>
                  </div>
                  <div className="bag-prod-details-second">
                    <span className="scnd-unit-price">
                      {product.PD_ProductType === "onhand" &&
                      product.PD_SalePrice > 0 ? (
                        <>
                          <strong>Sale Price: </strong> PHP{" "}
                          {product.PD_SalePrice}
                        </>
                      ) : (
                        <>
                          <strong>Unit Price: </strong> PHP{" "}
                          {product.PD_OriginalPrice}
                        </>
                      )}
                    </span>

                    <span>
                      <strong>Quantity: </strong>
                    </span>
                    <div className="scnd-quantity-wrapper">
                      <input
                        type="text"
                        value={product.B_Quantity}
                        onChange={(e) => {
                          const onlyDigits = Number(
                            e.target.value.replace(/\D/g, "").slice(0, 11)
                          );
                          if (product.PD_ProductType === "onhand") {
                            if (product.PD_Stock < onlyDigits)
                              updateQuantity(
                                product.B_ID,
                                product.PD_Stock || 0
                              );
                            else updateQuantity(product.B_ID, onlyDigits || 0);
                          } else updateQuantity(product.B_ID, onlyDigits || 0);
                        }}
                      />
                      <button
                        className="minus"
                        onClick={() =>
                          updateQuantity(product.B_ID, product.B_Quantity - 1)
                        } // will delete if = 1
                      >
                        <FaMinus />
                      </button>
                      <button
                        className="plus"
                        onClick={() => {
                          if (product.PD_ProductType === "onhand") {
                            if (product.PD_Stock > product.B_Quantity)
                              updateQuantity(
                                product.B_ID,
                                product.B_Quantity + 1
                              );
                          } else
                            updateQuantity(
                              product.B_ID,
                              product.B_Quantity + 1
                            );
                        }}
                      >
                        <FaPlus />
                      </button>
                    </div>
                  </div>
                </div>

                <span
                  className="bag-prod-trash-icon"
                  onClick={() => deleteItem(product.B_ID)}
                >
                  <FaTrash />
                </span>
              </div>
            ))
          ) : (
            <div className="no-products">No products added to the bag.</div>
          )}
        </div>
        {isMobile && (
          <button
            className="mobile-summary-toggle"
            onClick={() => handleMobileOrder()}
          >
            VIEW ORDER SUMMARY
          </button>
        )}
      </main>
      {isMobile ? (
        <aside
          className={`bag-order-summary-container ${
            isSummaryOpen ? "open" : ""
          }`}
          onClick={() => setIsSummaryOpen(false)}
        >
          <div className={`drawer-overlay `}>
            <div className={`bag-order-summary-card`}>
              <span
                className="drawer-close-btn"
                onClick={() => setIsSummaryOpen(false)}
              >
                <FaTimes />
              </span>
              <span className="summary-title">ORDER SUMMARY</span>
              <table className="table-prod-details-summary">
                <tbody>
                  {insideBag.map((item) =>
                    checkedItems.has(item.B_ID) ? (
                      <tr key={item.B_ID}>
                        <td>{item.PD_Name}</td>
                        <td>x {item.B_Quantity}</td>
                        <td>
                          {item.PD_ProductType === "onhand"
                            ? item.PD_SalePrice === 0
                              ? `PHP ${item.B_Quantity * item.PD_OriginalPrice}`
                              : `PHP ${item.B_Quantity * item.PD_SalePrice}`
                            : `PHP ${item.B_Quantity * item.PD_OriginalPrice}`}
                        </td>
                      </tr>
                    ) : null
                  )}
                </tbody>
              </table>
              <table className="table-total">
                <tbody>
                  <tr className="tr-total">
                    <td>TOTAL AMOUNT</td>
                    <td>
                      PHP{" "}
                      {insideBag
                        .reduce((sum, item) => {
                          if (!checkedItems.has(item.B_ID)) return sum;

                          // Use sale price only if product is "onhand" and has a valid sale
                          const price =
                            item.PD_ProductType === "onhand" &&
                            item.PD_SalePrice > 0
                              ? item.PD_SalePrice
                              : item.PD_OriginalPrice;

                          return sum + item.B_Quantity * price;
                        }, 0)
                        .toLocaleString(undefined, {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        })}
                    </td>
                  </tr>
                  <tr className="tr-downpayment">
                    <td c>TOTAL DOWNPAYMENT</td>
                    <td>
                      PHP{" "}
                      {insideBag.reduce(
                        (sum, item) =>
                          checkedItems.has(item.B_ID)
                            ? sum + item.B_Quantity * item.PD_DownPayment
                            : sum,
                        0
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <button
                disabled={checkedItems.size === 0 || loading}
                onClick={handlePlaceOrder}
              >
                {loading ? "Placing order..." : "PLACE ORDER"}
              </button>
            </div>
          </div>
        </aside>
      ) : (
        <aside
          className={`bag-order-summary-container ${
            isSummaryOpen ? "open" : ""
          }`}
        >
          <div className={`drawer-overlay `}>
            <div className="bag-order-summary-card">
              <span className="summary-title">ORDER SUMMARY</span>
              <table className="table-prod-details-summary">
                <tbody>
                  {insideBag.map((item) =>
                    checkedItems.has(item.B_ID) ? (
                      <tr key={item.B_ID}>
                        <td>{item.PD_Name}</td>
                        <td>x {item.B_Quantity}</td>
                        <td>
                          {item.PD_ProductType === "onhand"
                            ? item.PD_SalePrice === 0
                              ? `PHP ${item.B_Quantity * item.PD_OriginalPrice}`
                              : `PHP ${item.B_Quantity * item.PD_SalePrice}`
                            : `PHP ${item.B_Quantity * item.PD_OriginalPrice}`}
                        </td>
                      </tr>
                    ) : null
                  )}
                </tbody>
              </table>
              <table className="table-total">
                <tbody>
                  <tr className="tr-total">
                    <td>TOTAL AMOUNT</td>
                    <td>
                      PHP{" "}
                      {insideBag
                        .reduce((sum, item) => {
                          if (!checkedItems.has(item.B_ID)) return sum;

                          // Use sale price only if product is "onhand" and has a valid sale
                          const price =
                            item.PD_ProductType === "onhand" &&
                            item.PD_SalePrice > 0
                              ? item.PD_SalePrice
                              : item.PD_OriginalPrice;

                          return sum + item.B_Quantity * price;
                        }, 0)
                        .toLocaleString(undefined, {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                        })}
                    </td>
                  </tr>
                  <tr className="tr-downpayment">
                    <td c>TOTAL DOWNPAYMENT</td>
                    <td>
                      PHP{" "}
                      {insideBag.reduce(
                        (sum, item) =>
                          checkedItems.has(item.B_ID)
                            ? sum + item.B_Quantity * item.PD_DownPayment
                            : sum,
                        0
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <button
                disabled={checkedItems.size === 0 || loading}
                onClick={handlePlaceOrder}
              >
                {loading ? "Placing order..." : "PLACE ORDER"}
              </button>
            </div>
          </div>
        </aside>
      )}
    </div>
  );
}
export default BagContent;
